<div class="wrapper wrapper-content">
  <div class="container-fluid p-0" *ngIf="isLoaded()">
    <div class="row">
      <div class="col-12">
        <div class="titleElement" *ngIf="authorizationType">
          {{'ProjectEntityUserAuthorization.TypeTitle.'+this.authorizationType | translate}} </div>
      </div>
      <div class="col-12">
        <p-table [value]="projectEntityUserAuthorizations" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <!--
                <th>
                  {{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.ProjectEntity'|translate}}
                </th>
                -->
              <th>
                {{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.User'|translate}}
              </th>
              <th *ngIf="!authorizationType">
                {{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.AuthorizationType'|translate}}
              </th>
              <th>
                {{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.AuthorizationDate'|translate}}
              </th>
              <th class="action-column-2"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-projectEntityUserAuthorization>
            <tr>
              <!--
                <td>
                  <span
                    class="p-column-title">{{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.ProjectEntity'|translate}}</span>
                  <divisionDetail [project]="projectEntityUserAuthorization?.projectEntity" [infoLink]="true"
                    [infoTitulo]="true" class="d-inline text-truncate float-left p-0" style="min-width: 50%;">
                  </divisionDetail>
                </td>
              -->
              <td>
                <span
                  class="p-column-title">{{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.User'|translate}}</span>
                <user [user]="projectEntityUserAuthorization?.user"></user>
              </td>
              <td *ngIf="!authorizationType">
                <span
                  class="p-column-title">{{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.AuthorizationType'|translate}}</span>
                {{projectEntityUserAuthorization?.authorizationType}}
              </td>
              <td>
                <span
                  class="p-column-title">{{'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.ProjectEntityUserAuthorizationsTable.ColumnHeaders.AuthorizationDate'|translate}}</span>
                {{projectEntityUserAuthorization?.authorizationDate|date:'dd/MM/yyyy HH:mm:ss'}}
              </td>
              <td class="action-column-2">
                <div class=" btn-group">
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    title="{{ 'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.Actions.DeleteProjectEntityUserAuthorization' | translate}}"
                    (click)="deleteProjectEntityUserAuthorization(projectEntityUserAuthorization)">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td colspan="5"><span>{{ 'General.noData' | translate }}</span></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div *ngIf="authorizationType === 'D' && adaptationCixtecEnabled" class="row">
      <div class="col-12">
        <div class="form-group">
          <button type="button" class="btn btn-primary btn-sm float-right m-t-sm" data-dismiss="modal"
            (click)="insertProjectEntityUserAuthorization()">
            <i class="fa-check fas" aria-hidden="true"></i> {{ 'General.add' | translate }}
          </button>
        </div>
      </div>
    </div>

    <daciExt *ngIf="authorizationType === 'D' && adaptationCixtecEnabled" [dossierID]="projectEntity.identifier">
    </daciExt>